import React, {
    forwardRef,
    KeyboardEventHandler,
    RefObject,
    useCallback,
    useEffect,
    useImperativeHandle,
    useRef
} from 'react'

type Props = {
    search          : string

    placeholder     : string

    onKeyDown?      : KeyboardEventHandler
    onSearchChange  : {(value:string):void}
    onSearchCancel  : {():void}
}

const debug = false
// const debug = "EntitySelectorSearchInput"

const EntitySelectorSearchInput = forwardRef((props:Props, ref) => {

    const inputRef: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null)

    useEffect(()=>{
        focus()
    }, [inputRef])

    const onSearchChange = useCallback((event:any)=>{
        const value = event.target.value ? event.target.value : ''
        props.onSearchChange(value)
    }, [])


    const focus = () => {
        setTimeout(()=>{
            inputRef.current?.focus()
        }, 200)
    }

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        focus,
    }))

    return (
        <div className="search-input">
            <input ref          = {inputRef}
                   className    = "gd-input small"
                   type         = "input"
                   placeholder  = {props.placeholder}
                   value        = {props.search}
                   onKeyDown    = {props.onKeyDown}
                   onChange     = {onSearchChange}/>
            <div className="ui5-ico-14 i5-search search-icon flex-row-center-center w-30 h-100-percent"/>

            {!!props.search &&
                <div className  = "ui5-ico-14 i5-close delete-button flex-row-center-center w-30 h-100-percent"
                     onClick    = {props.onSearchCancel}/>}
        </div>
    )
})

export default EntitySelectorSearchInput
